<script>
export default {
  name: "MultiDatePicker",
  props: {
    value: { type: Array, default: () => [] }, // array de fechas
    readonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val); // emite el array de fechas
    },
  },
};
</script>

<template>
  <div class="multi-date">
    <el-date-picker
      v-if="!readonly"
      type="dates"
      :value="value"
      @input="onInput"
      format="dd/MM/yyyy"
      value-format="dd/MM/yyyy"
      :disabled="isDisabled"
      placeholder="Seleccione fechas"
    >
    </el-date-picker>

    <el-input v-else :value="(value || []).join(', ')" readonly> </el-input>
  </div>
</template>

<style scoped>
.multi-date {
  width: 100%;
}
</style>
